export default __webpack_public_path__ + "static/media/correspondent9.b17b33bc.png";